var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager-tab__mobile", on: { click: _vm.activateModal } },
    [
      _c(
        "div",
        {
          staticClass: "manager-tab__mobile-image",
          style: "background-image: url(" + _vm.item.headshot + ")"
        },
        [_c("div", { staticClass: "manager-tab__mobile-angle-block" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "manager-tab__mobile-identity" }, [
        _c("p", [
          _vm._v("Contact"),
          _c("br"),
          _c("strong", [_vm._v(_vm._s(_vm.item.title))])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }